const wrapper = (fn, errorHandler, sendAlert) => {
  return fn()
    .then((res) => {
      if (sendAlert) {
        sendAlert({
          snackbarMessage: 'عملیات با موفقیت انجام شد',
          snackbarOpen: true,
          snackBarSeverity: 'success',
        });
      }

      return res;
    })
    .catch((error) => {
      errorHandler?.(error);
      throw error;
    });
};

export default wrapper;
